{
  "auth": {
    "welcome": "welcome to the otherverse",
    "loginSubtitle": "Ingresa tus credenciales para certificar",
    "usernameLabel": "Usuario o correo",
    "usernamePlaceholder": "Ingresa tu usuario o correo...",
    "passwordLabel": "Contraseña",
    "certifyButton": "Certificar",
    "forgotPasswordLink": "¿Olvidaste tu usuario o contraseña?",
    "forgotPasswordTitle": "Recuperar acceso",
    "forgotPasswordSubtitle": "Ingresa tu usuario o correo y te mandamos un link para elegir una contraseña nueva.",
    "forgotPasswordSent": "Si la cuenta existe, te enviamos un correo con instrucciones.",
    "forgotPasswordCooldownTimer": "Puedes solicitarlo de nuevo en {{time}}.",
    "resetPasswordTitle": "Elegir contraseña nueva",
    "resetPasswordSubtitle": "Escribe tu contraseña nueva para tu cuenta en Colonny.",
    "resetPasswordSubmit": "Guardar contraseña",
    "resetPasswordSuccess": "Tu contraseña se actualizó correctamente. Ya puedes iniciar sesión con ella.",
    "resetPasswordNoToken": "Este link no es válido. Solicita uno nuevo desde la pantalla de inicio de sesión.",
    "resetPasswordNewPasswordPlaceholder": "Mínimo 8 caracteres...",
    "resetPasswordTooShort": "La contraseña debe tener al menos 8 caracteres.",
    "resetPasswordMismatch": "Las contraseñas no coinciden.",
    "resetPasswordError": "Error al conectar con el servidor.",
    "forgotPasswordIdentifierLabel": "Usuario o correo",
    "forgotPasswordIdentifierPlaceholder": "Ingresa tu usuario o correo...",
    "forgotPasswordSubmit": "Enviar",
    "forgotPasswordSending": "Enviando...",
    "backToLogin": "Volver a iniciar sesión",
    "onboardingPasswordTitle": "Personaliza tu contraseña",
    "onboardingPasswordSubtitle": "Asegura tu cuenta para continuar",
    "newPasswordLabel": "Nueva Contraseña",
    "newPasswordPlaceholder": "Mínimo 4 caracteres...",
    "confirmPasswordLabel": "Confirmar Contraseña",
    "confirmPasswordPlaceholder": "Vuelve a escribir la contraseña...",
    "nextButton": "Siguiente",
    "nickLabel": "Coloca tu nick",
    "nickPlaceholder": "Tu nombre visible...",
    "emailLabel": "Coloca tu correo electronico",
    "emailPlaceholder": "usuario@dominio.com",
    "nickTaken": "nickname ocupado",
    "emailTaken": "correo ocupado / error",
    "profileCompletionTitle": "Concluye tu perfil",
    "profileCompletionSubtitle": "Cuéntanos un poco más de ti",
    "descriptionLabel": "Descripción (Max 350)",
    "descriptionPlaceholder": "Dinos algo breve sobre ti...",
    "locationLabel": "Ubicación",
    "locationPlaceholder": "Tu ciudad, país...",
    "religionLabel": "Religión",
    "religionPlaceholder": "Opcional...",
    "birthDateLabel": "Fecha de nacimiento",
    "documentationTitle": "Documentación",
    "documentationSubtitle": "Sube tus documentos para validar tu identidad",
    "documentationRequired": "Todos los documentos excepto RFC son obligatorios",
    "idFront": "ID Frente",
    "idBack": "ID Atrás",
    "proofOfAddress": "Comprobante de domicilio",
    "curp": "CURP",
    "birthCertificate": "Acta de nacimiento",
    "rfcLabel": "RFC (Opcional)",
    "startAdventureButton": "Comenzar Aventura",
    "addProfilePhoto": "Agregar foto de perfil",
    "addProfilePhotoHint": "(Click o Arrastrar)"
  },
  "nav": {
    "home": "Inicio",
    "docs": "Docs",
    "database": "Database",
    "calendar": "Calendario",
    "tasks": "Tareas",
    "profile": "Perfil",
    "logout": "Cerrar Sesión",
    "allSpaces": "Todos los espacios"
  },
  "common": {
    "language": "Idioma",
    "timezone": "Zona horaria",
    "timezoneSelectPlaceholder": "Selecciona una zona horaria",
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "create": "Crear",
    "search": "Buscar",
    "loading": "Cargando...",
    "noResults": "No hay resultados",
    "confirm": "Confirmar",
    "close": "Cerrar",
    "onlyMine": "Solo mis tareas",
    "allItems": "Todas las tareas",
    "onlyMineTooltipOn": "Mostrando solo tus tareas y eventos — clic para ver los de todos",
    "onlyMineTooltipOff": "Mostrando tareas y eventos de todos — clic para ver solo los tuyos",
    "noDate": "Sin fecha"
  },
  "relativeDate": {
    "today": "hoy",
    "tomorrow": "mañana",
    "inDays": "en {{count}} días",
    "yesterday": "ayer",
    "twoDaysAgo": "hace dos días",
    "daysAgo": "hace {{count}} días",
    "oneWeekAgo": "hace una semana",
    "twoWeeksAgo": "hace dos semanas",
    "threeWeeksAgo": "hace tres semanas",
    "fourWeeksAgo": "hace cuatro semanas",
    "oneMonthAgo": "hace un mes",
    "monthsAgo": "hace meses"
  }
}
